import StandardQueryTable from "@/components/StandardQueryTable";
import { PATH_EMAIL_TYPE } from "@/constants";
import { useEmailTypeBreadcrumbs } from "@/modules/email-types/hooks/useEmailTypeBreadcrumbs";
import { useEmailTypesListColumnOverrides } from "@/modules/email-types/hooks/useEmailTypesListColumnOverrides";
import { EmailTypeService } from "@/services/emailType";
import { displayEmailType } from "@/schemas/emailType";
import { DisplayEmailType } from "@/types/emailType";
import { generatePath } from "react-router-dom";

export const EmailTypesList = () => {
  const breadcrumbs = useEmailTypeBreadcrumbs();
  const columnOverrides = useEmailTypesListColumnOverrides();

  return (
    <StandardQueryTable<DisplayEmailType>
      schema={displayEmailType}
      name="emailTypes"
      fetchList={EmailTypeService.getTypes}
      breadcrumbs={breadcrumbs}
      translationKey="emailTypes"
      columnOverrides={columnOverrides}
      pathBuilder={(row) =>
        generatePath(PATH_EMAIL_TYPE, { emailTypeId: row.id })
      }
      actions={[]}
      tableFeatures={{
        initialColumnVisibility: {
          allowed_roles: false,
        },
      }}
    />
  );
};
